import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Container, Label, LabelMinimal,
} from './styled';

function Button({
  link,
  icon,
  secondary,
  danger,
  labelStyle,
  label = '',
  onClick = () => { },
  style,
  submit,
  validate = () => false,
  setRef,
  minimal,
  target='_blank',
  ...other
}) {
  let LabelComponent = Label;

  if (typeof minimal !== 'undefined') {
    LabelComponent = LabelMinimal;
  }

  const [buttonRef, setButtonRef] = useState(null);
  const data_attr = other['data-cy'] || null;
  return (
    <Container as={link ? 'a' : typeof submit !== 'undefined' ? 'button' : 'div'} {...other} id={label.toLowerCase().split(' ').join('-')} data-cy={data_attr} danger={danger} minimal={minimal} _secondary={secondary} ref={(buttonRef) => {
      setButtonRef(buttonRef);

      if (setRef && (buttonRef && buttonRef.current !== null)) {
        setRef(buttonRef);
      }
    }}
    type={submit ? 'submit' : undefined}
    style={{ ...style }}
    onClick={(e) => {
      if (!submit) {
        onClick();
      } else {
        if (buttonRef) {
          const form = buttonRef.form;

          $(form)
            .unbind('submit')
            .bind('submit', e => {
              e.preventDefault();
              e.stopPropagation();
              $(this).unbind(e);
              const alertMessage = validate();

              if (alertMessage) {
                return alert(alertMessage);
              } else {
                onClick();
              }
              return false;
            });
        }
      }
    }}
    target={target}
    href={link}>
      {icon && <img src={icon} />}
      <LabelComponent as="label" _secondary={secondary} style={labelStyle}>
        {label}
      </LabelComponent>
    </Container>
  );
}

Button.propTypes = {
  /**
   * The label of the button
   */
  label: PropTypes.string.isRequired,
  secondary: PropTypes.bool,
};

export default Button;
